// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rwtp_","label":"styles_label__7ayRU"};